"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconType = exports.IconLibrary = void 0;
var IconLibrary = exports.IconLibrary = /*#__PURE__*/function (IconLibrary) {
  IconLibrary["GoogleMaterial"] = "ic";
  IconLibrary["MaterialSymbolsRounded"] = "material-symbols-rounded";
  IconLibrary["MaterialSymbols"] = "material-symbols";
  IconLibrary["FontAwesomeRegular"] = "fa6-regular";
  return IconLibrary;
}({});
;
var IconType = exports.IconType = /*#__PURE__*/function (IconType) {
  IconType["Home"] = "home";
  IconType["Check"] = "check";
  IconType["ArrowRight"] = "arrow-right";
  IconType["ChevronRight"] = "chevron-right";
  IconType["ArrowLeft"] = "arrow-left";
  IconType["ChevronLeft"] = "chevron-left";
  IconType["ArrowDown"] = "arrow-down";
  return IconType;
}({});